import { motion } from "framer-motion";

function Contact() {
  return (
    <section className="min-h-screen bg-black text-white flex items-center justify-center 
    px-4 sm:px-6 md:px-20 py-16 pt-28 md:pt-32 relative overflow-hidden">

      {/* 🔥 Background Glow */}
      <div className="absolute w-[300px] h-[300px] md:w-[500px] md:h-[500px] bg-green-400/10 blur-3xl rounded-full top-10 left-1/2 -translate-x-1/2"></div>

      <div className="relative z-10 w-full max-w-6xl grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">

        {/* 🟢 LEFT INFO (Bottom → Up) */}
        <motion.div
          className="text-center md:text-left"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold leading-tight">
            Get in <span className="text-green-400">Touch</span>
          </h1>

          <p className="mt-4 md:mt-6 text-gray-400 text-sm sm:text-base max-w-md mx-auto md:mx-0">
            Have questions or need help? Reach out to us and we’ll respond quickly.
          </p>

          <div className="mt-6 md:mt-8 space-y-3 md:space-y-4 text-gray-300 text-sm sm:text-base">
            <p>📍 Kanpur, India</p>
            <p>📧 support@printezz.com</p>
            <p>📞 +91 8957160738</p>
          </div>

        </motion.div>

        {/* 🟢 RIGHT FORM (Top → Down) */}
        <motion.div
          className="bg-black/60 border border-green-400/20 rounded-xl p-4 sm:p-6 md:p-8 backdrop-blur-md shadow-lg"
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >

          <form className="space-y-4">

            <input
              type="text"
              placeholder="Your Name"
              className="w-full p-3 text-sm sm:text-base bg-black border border-gray-700 rounded-md focus:border-green-400 outline-none"
            />

            <input
              type="email"
              placeholder="Your Email"
              className="w-full p-3 text-sm sm:text-base bg-black border border-gray-700 rounded-md focus:border-green-400 outline-none"
            />

            <textarea
              rows="4"
              placeholder="Your Message"
              className="w-full p-3 text-sm sm:text-base bg-black border border-gray-700 rounded-md focus:border-green-400 outline-none resize-none"
            ></textarea>

            <button className="w-full py-3 text-sm sm:text-base border border-green-400 text-green-400 
            hover:bg-green-400 hover:text-black transition duration-300
            shadow-[0_0_12px_#00ff9f] rounded-md">
              SEND MESSAGE →
            </button>

          </form>

        </motion.div>

      </div>

    </section>
  );
}

export default Contact;